<template>
  <div id="test">
    <globalDashboard :dashboardLayout="dashboardDataResult"></globalDashboard>
  </div>
</template>

<script>
import globalDashboard from "@/views/components/dashboard/GlobalDashboard";

export default {
  components: {
    globalDashboard,
  },
  setup() {
    const dashBoardData = `
    {
      "mapping":[
        [
          {
            "col":6,
            "cards":["card_1"]
          }
        ],
        [
          {
            "col":3,
            "cards":["card_2"]
          },
          {
            "col":9,
            "cards":["card_3"]
          }
        ]
      ],
      "data":{
        "card_1":{
          "id":"card_1",
          "type":"test_card",
          "payload":{
            "query_data":{
              "key":"DashboardTotalCustomer",
              "custom":"api full path"
            }
          },
          "config":{
            "title":"Yay Dragon",
            "right_title":"",
            "button_right_top":{
              
            },
            "bg_color":"#550000"
          }
        },
        "card_2":{
          "id":"card_2",
          "type":"test_card",
          "payload":{
            "query_data":{
              "key":"DashboardTotalCustomer",
              "custom":"api full path"
            }
          },
          "config":{
            "title":"Yay Dragon",
            "right_title":"",
            "button_right_top":{
              
            },
            "bg_color":"#550000"
          }
        },
        "card_3":{
          "id":"card_3",
          "type":"multi_level_line",
          "payload":{
            "mapping":[
              [
                {
                  "col":6,
                  "cards":["card_4"]
                },
                {
                  "col":6,
                  "cards":["card_5"]
                }
              ]
            ]
          },
          "config":{
          }
        },
        "card_4":{
          "id":"card_4",
          "type":"test_card",
          "payload":{
            "query_data":{
              "key":"DashboardTotalCustomer",
              "custom":"api full path"
            }
          },
          "config":{
            "title":"Yay Dragon",
            "right_title":"",
            "button_right_top":{
              
            },
            "bg_color":"#550000"
          }
        },
        "card_5":{
          "id":"card_5",
          "type":"test_card",
          "payload":{
            "query_data":{
              "key":"DashboardTotalCustomer",
              "custom":"api full path"
            }
          },
          "config":{
            "title":"Yay Dragon",
            "right_title":"",
            "button_right_top":{
              
            },
            "bg_color":"#550000"
          }
        }
      }
    }
    `

    let dashboardDataResult = JSON.parse(dashBoardData)

    console.log(dashboardDataResult)
    return {
      dashboardDataResult
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";

#quiz-list .w-50px {
  width: 50px;
}
</style>